'use client';

import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import WomanDetailModal from './detail-modal';
import SliderActiveItem from './slider-active-item';
import SliderProgressBar from './slider-progress-bar';
import WomenSlider from './women-slider';
import WomenSliderSkeleton from './women-slider-skeleton';
import { computeCarouselLayout, computeOriginalIndex } from '../../_utils/carousel-layout';
import { filterItemsByCategory } from '../../_utils/filter-items-by-category';
import { useFetchIranianWomenData } from '../../_utils/use-fetch-iranian-women-data';
import { useShuffledItems } from '../../_utils/use-shuffled-items';
import { useWomenCarousel } from '../../_utils/use-women-carousel';
interface Props {
  selectedCategory: string | null;
}
const MainSection = ({
  selectedCategory
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    data
  } = useFetchIranianWomenData();
  const shuffledItems = useShuffledItems(data?.items);
  const filteredItems = filterItemsByCategory(shuffledItems, selectedCategory);
  const {
    slides,
    totalSlides,
    perView,
    visibleSideCount,
    originalLength,
    baseItems
  } = computeCarouselLayout(filteredItems, isMobile, 0);
  const {
    activeIndex,
    setActiveIndex,
    details,
    detailsDirection,
    isCarouselReady,
    handleCloseDetailsModal,
    handleNavigateDetailsModal,
    handleDetailsChanged,
    setDetails
  } = useWomenCarousel({
    selectedCategory,
    isMobile,
    slides,
    totalSlides,
    perView,
    visibleSideCount
  });
  const originalIndex = computeOriginalIndex(activeIndex, originalLength);
  const activeItem = baseItems[originalIndex];
  if (!data?.items || !shuffledItems || !isCarouselReady) return <WomenSliderSkeleton />;
  return <div className='-mx-2 flex flex-col lg:mx-auto lg:max-w-4xl' data-sentry-component="MainSection" data-sentry-source-file="index.tsx">
            <SliderProgressBar originalIndex={originalIndex} originalLength={originalLength} data-sentry-element="SliderProgressBar" data-sentry-source-file="index.tsx" />

            <WomenSlider perView={perView} setActiveIndex={setActiveIndex} selectedCategory={selectedCategory} activeIndex={activeIndex} activeItem={activeItem ?? null} handleDetailsChanged={handleDetailsChanged} slides={slides} totalSlides={totalSlides} visibleSideCount={visibleSideCount} setDetails={setDetails} data-sentry-element="WomenSlider" data-sentry-source-file="index.tsx" />

            {activeItem && <SliderActiveItem {...activeItem} />}

            <WomanDetailModal details={details} direction={detailsDirection} handleCloseDetailsModal={handleCloseDetailsModal} handleNavigateDetailsModal={handleNavigateDetailsModal} data-sentry-element="WomanDetailModal" data-sentry-source-file="index.tsx" />
        </div>;
};
export default MainSection;